import { Paper, Box, Typography, Stack } from '@mui/material';

/**
 * Empty states are where a new clinic forms its first impression, so they get a
 * real design rather than a blank table. Generalised from the one good example
 * in the previous build (the patient list).
 *
 * @param icon    element rendered in the tinted circle
 * @param title   what's absent, in plain language
 * @param body    what to do about it
 * @param action  the button that does it
 * @param variant 'paper' (standalone) | 'inline' (inside an existing surface)
 */
const EmptyState = ({ icon, title, body, action, variant = 'paper', sx }) => {
  const content = (
    <Stack alignItems="center" spacing={1.5} sx={{ py: variant === 'paper' ? 6 : 4, px: 3, textAlign: 'center' }}>
      {icon && (
        <Box
          sx={{
            width: 56, height: 56, borderRadius: '50%',
            display: 'grid', placeItems: 'center',
            bgcolor: 'grey.100', color: 'text.secondary', mb: 0.5,
          }}
        >
          {icon}
        </Box>
      )}
      <Typography variant="h4">{title}</Typography>
      {body && (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 380 }}>
          {body}
        </Typography>
      )}
      {action && <Box sx={{ pt: 1 }}>{action}</Box>}
    </Stack>
  );

  if (variant === 'inline') return <Box sx={sx}>{content}</Box>;
  return <Paper sx={sx}>{content}</Paper>;
};

export default EmptyState;
